/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import Swal from 'sweetalert2';
import MDButton from 'components/MDButton';
import MDDatePicker from 'components/MDDatePicker';
import MDTimePicker from 'components/MDTimePicker';
import { api } from '../../../api';
import {
  TEAL,
  TIME_PICKER_STEP_MINUTES,
  formatDisplayDate,
  formatDisplayTime,
  formatTimeFor24Hour,
  getCurrentUserId,
} from '../constants';

export default function RescheduleDialog({ appointment, onClose, onDone }) {
  const [newDate, setNewDate] = useState(appointment.appointment_date);
  const [newTime, setNewTime] = useState(appointment.appointment_time || '');
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    if (!newDate) {
      Swal.fire({ icon: 'warning', title: 'New date is required' });
      return;
    }
    const confirmResult = await Swal.fire({
      title: 'Reschedule this appointment?',
      html: `New date: <b>${formatDisplayDate(newDate)}</b>${newTime ? ` at <b>${formatDisplayTime(newTime)}</b>` : ''}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: TEAL,
      confirmButtonText: 'Yes, Reschedule',
      cancelButtonText: 'Cancel',
    });
    if (!confirmResult.isConfirmed) return;

    setSubmitting(true);
    try {
      await api.appointment.reschedule(appointment.id, {
        new_date: newDate,
        new_time: formatTimeFor24Hour(newTime),
        reason: reason || undefined,
        updated_by: getCurrentUserId(),
      });
      Swal.fire({ icon: 'success', title: 'Appointment rescheduled', timer: 1800, showConfirmButton: false });
      onDone?.();
    } catch {
      // generic error toast already shown by ApiClient
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Reschedule Appointment</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <MDDatePicker label="New Date" value={newDate} onChange={setNewDate} />
          <MDTimePicker
            label="New Time (optional)"
            value={newTime}
            onChange={val => setNewTime(val || '')}
            minutesStep={TIME_PICKER_STEP_MINUTES}
            textFieldProps={{ fullWidth: true }}
          />
          <TextField
            label="Reason (optional)"
            size="small"
            fullWidth
            multiline
            minRows={2}
            value={reason}
            onChange={e => setReason(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="secondary">Cancel</MDButton>
        <MDButton onClick={handleSubmit} disabled={submitting} variant="gradient" color="logo">
          {submitting ? 'Saving…' : 'Reschedule'}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
